import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const EmitirNFeForm = styled(Box)`
    width: 100%;
    min-width: 520px;
    height: 100%;
    display: flex;
    padding: 1rem;
    gap: 1rem;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: column;
`
